import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { getPageSize, trans } from "utils/helpers";
import { deleteDataGrid, getDataCollection, postDataCollection } from "./api";

import { FormBuilder } from "../../FormBuilder";
import { MessageType } from "types/enum";
import { Toast } from "components/ToastShow/ToastAlert";
import { ExportDynamicForm } from "../../api";
import { ImportForm } from "../ImportForm";
interface DynamicFormDataGridPropsType {
  onHide: (e: boolean) => void;

  mode: "create" | "view" | "edit";
  setChanged?: any;
}

export const DynamicFormDataGrid = ({
  onHide,
  mode,
  setChanged,
}: DynamicFormDataGridPropsType) => {
  const [userChanges, setUserChanges] = useState({});
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [response, setResponse] = useState<any>([]);
  const [selectedObj, setSelectedObj] = useState<string | any>(null);
  const [showPropertiesForm, setShowPropertiesForm] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [detailById, setDetailById] = useState<any>("");
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const [pages, setPages] = useState<number>(0);
  const [detailMode, setDetailMode] = useState<any>();
  const [search, setsearch] = useState<any>("");
  const [selectList, setSelectList] = useState<any>([]);
  const [resetMultiSelect, setResetMultiSelect] = useState<any>(false);
  const [showImportForm, setShowImportForm] = useState(false);
  const [designMode,setDesignMode]=useState(false)

  const [acceptRestroeData, setAcceptRestroeData] = useState<any>(false);
  const [reStoreData, setRestoreData] = useState<any>();



  const handleChangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("DynamicFormDataGrid", e.currentTarget.value);
    getDataCollectionAsync(1);
  };
  const handleGoPage = (value) => {
    if (value) {
      setPageNum(+value);
      getDataCollectionAsync(+value);
    } else {
    }
  };
  const handleNextPage = () => {
    if (response.TotalRecords && response.TotalRecords / pageSize > pageNum) {
      setPageNum((pageNum) => {
        return +pageNum + 1;
      });
      getDataCollectionAsync(pageNum + 1);
    }
  };
  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getDataCollectionAsync(pageNum - 1);
    }
  };

  const getDataCollectionAsync = async (
    pagNum = pageNum,
    SearchString = search
  ) => {
    setLoading(false);

    try {
      let pageSizeChangedByUser = getPageSize("DynamicFormDataGrid");
      setPageSize(pageSizeChangedByUser);
      const res = await getDataCollection(pagNum, pageSizeChangedByUser);

      if (res.Data.TotalRecords > 0) {
        setResponse(res.Data);
        setPages(
          res.Data.TotalRecords > pageSizeChangedByUser
            ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser)
            : 1
        );
      }
    } catch (error) {}
    setLoading(true);
  };

  const handleDeleteRow = async () => {
    try {
      const res = await deleteDataGrid(selectedObj.Id);
      setForceUpdate(!forceUpdate);
      setChanged(true);
    } catch (error) {}
  };

  function cancel() {
    setShowForm(false);
    sessionStorage.setItem("changingforms", "false");
              const newData= JSON.parse(localStorage.getItem("unSavedData") as any)??{}

            delete newData?.datatables
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
  }

  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
    setShowForm(false);
    sessionStorage.setItem("changingforms", "false");
  };
  const handleImport = async () => {
    setShowImportForm(true);
  };
  const handleExportAsync = async () => {
    let SystemKeyList = selectList.map((item) => {
      return item.SystemKey;
    });
    try {
      const respons = await ExportDynamicForm(null, SystemKeyList);
      const contentDisposition = respons.headers["file-name"];
      let fileName = "downloaded-file"; // Default filename
      if (contentDisposition) {
        fileName = contentDisposition.split(".")[0];
      }
      var pom = document.createElement("a");
      pom.setAttribute("href", window.URL.createObjectURL(respons.data));
      pom.setAttribute("download", fileName);
      pom.click();
      setSelectList([]);
      setResetMultiSelect(!resetMultiSelect);
    } catch (error) {}
  };
  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "refresh":
        setForceUpdate(!forceUpdate);
        break;
      case "create":
        {
          setShowForm(true);
          setDesignMode(false)
          setDetailMode("create");
        }
        break;
      case "export":
        if (selectList.length > 0) handleExportAsync();
        break;
      case "import":
        handleImport();
        break;
      case "edit":
        if (selectedObj?.Id) {
          setShowForm(true);
          setDesignMode(false)
          setDetailMode("edit");
        }
        break;
        case "design":
        if (selectedObj?.Id) {
          setShowForm(true);
          setDesignMode(true)
          setDetailMode("edit");
        }
        break;
      case "view":
        if (selectedObj?.Id) {
          setShowForm(true);
          setDetailMode("view");
        }
        break;
      case "remove":
        if (selectedObj?.Id) {
          Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete, () =>
            handleDeleteRow()
          );
        }
    }
  };
  const selectListCallBack = (list) => {
    setSelectList(list[1]);
  };
  useEffect(() => {
    getDataCollectionAsync();
  }, [forceUpdate]);

  useEffect(() => {
    let newInputList =
      localStorage.getItem("unSavedData") &&
      JSON.parse(localStorage.getItem("unSavedData") + "")?.datatables;
      
    if (
      newInputList &&
      newInputList.inputs.length > 0 &&
    (  newInputList?.detailForm?.DynamicForms != null || (newInputList?.detailForm != null && !newInputList?.detailForm?.DynamicForms))&&
      newInputList?.countList != null
    ) {
      setRestoreData({
        Id: newInputList?.detailForm?.DynamicForms?.Id ||  newInputList?.detailForm?.Id,
        Priority: newInputList?.detailForm?.DynamicForms?.FormPriority || newInputList?.detailForm?.FormPriority,
        SystemKey: newInputList?.detailForm?.DynamicForms?.SystemKey || newInputList?.detailForm?.SystemKey,
        Title: newInputList?.detailForm?.DynamicForms?.formTitle || newInputList?.detailForm?.formTitle,
        TitleEN: newInputList?.detailForm?.DynamicForms?.FormTitleEN ||  newInputList?.detailForm?.FormTitleEN,
      });

      Toast(
        trans("areyousuretorecoverunsaveddata"),
        MessageType.confirm,
        () => {
          setAcceptRestroeData(true);

          if (newInputList?.detailForm?.DynamicForms?.Id ||  newInputList?.detailForm?.Id) {
            setShowForm(true);
            setDetailMode("edit");
          } else {
            setDetailMode("create");
            setShowForm(true);
          }
        },
        null,
        () => {
          setAcceptRestroeData(false);
          /////localStorage.removeItem(createGrid?"datatables": "formbuilder");
          const newData =
            JSON.parse(localStorage.getItem("unSavedData") as any) ?? {};
          delete newData?.datatables;
          if (Object.keys(newData)?.length > 0) {
            localStorage.setItem("unSavedData", JSON.stringify(newData));
          } else {
            localStorage.removeItem("unSavedData");
          }
          sessionStorage.setItem("changingforms", "false");
        }
      );
    }
  }, [resetForm]);
  


  return (
    <>
      <Toolbar
          id={selectedObj?.Id}
        emptyList={response?.TotalRecords == 0 || response?.Data == null}
        create={true}
        edit={true}
        remove={true}
        Export={true}
        design={true}
        handleClickToolbar={clickToolbarCallback}
        Importprocesses={true}
      />
      {showImportForm && (
        <ModalForm
          modalHeight={80}
          modalProfileKey={"Users"}
          title={"import"}
          onHide={() => setShowImportForm(false)}
          show={showImportForm}
        >
          <ImportForm
            reload={() => {
              setShowImportForm(false);
              setForceUpdate(!forceUpdate);
            }}
            showForm={() => {
              setShowImportForm(false);
            }}
          />
        </ModalForm>
      )}
      {showForm && (
        detailMode=="view" || designMode?
        <ModalForm
          title={
            trans("DataGridForm") +
        (  detailMode=='create'?'':  (acceptRestroeData?` ( ${reStoreData.Title} )` :selectedObj?.Title ? ` ( ${selectedObj?.Title} )` : ""))
          }
          show={showForm}
          openFullscreen={true}
          onHide={() => {
           cancel()
        setDesignMode(false)
          }}
        >
          <FormBuilder
            acceptRestroeData={acceptRestroeData}
            designMode={designMode}
            setAcceptRestroeData={setAcceptRestroeData}
            reload={() => {
        setDesignMode(false)

              setForceUpdate(!forceUpdate);
              setShowForm(false);
              sessionStorage.setItem("changingforms", "false");
            }}
            createGrid={true}
            gridPageMode={detailMode}
            selectedObj={acceptRestroeData ? reStoreData : selectedObj}
          />
        </ModalForm>:
        <FormBuilder
            acceptRestroeData={acceptRestroeData}
            setAcceptRestroeData={setAcceptRestroeData}
            reload={() => {
              setForceUpdate(!forceUpdate);
              setShowForm(false);
              setDesignMode(false)

              sessionStorage.setItem("changingforms", "false");
            }}
            designMode={designMode}

            createGrid={true}
            gridPageMode={detailMode}
            selectedObj={acceptRestroeData ? reStoreData : selectedObj}
          />

      )}

      {loading ? (
        <>
          {response?.Data?.length > 0 ? (
            <div className="card">
              <div className="card-body p-0">
                <>
                  <DataGrid
                    multiSelect={true}
                    selectList={selectListCallBack}
                    resetMultiSelect={resetMultiSelect}
                    DoubleClick={(obj) => {
                      setSelectedObj(obj);
                      // clickToolbarCallback("view");
                    }}
                    View={true}
                    ViewParametr={"NotSeen"}
                    // handlefiltering={(str: any) => {
                    //   str.Filterlist != undefined
                    //     ? setFilterAndSort(str)
                    //     : setFilterAndSort({
                    //         ...filterAndSort,
                    //         Filterlist: str,
                    //       });
                    // }}
                    // filterStr={filterAndSort.Filterlist}
                    // orderFormatList={filterAndSort.OrderFormat}
                    // orderFormat={(order) => {
                    //   setFilterAndSort({
                    //     ...filterAndSort,
                    //     OrderFormat: order,
                    //   });
                    // }}
                    handleDelete={(e) => {
                      Toast(
                        trans("msg_deleteconfirm"),
                        MessageType.confirmDelete,
                        () => handleDeleteRow()
                      );
                    }}
                    parentName={"DynamicFormDataGrid"}
                    theadData={Object.keys(response.Data[0])}
                    tbodyData={response.Data}
                    minCellWidth={80}
                    selectedRowObjectCallback={selectedObjCallback}
                    rowSelected={selectedObj}
                    startIndex={1}
                    totalRecords={response.TotalRecords}
                    pageNum={pageNum}
                    pageSize={pageSize}
                    HandleNextPage={handleNextPage}
                    HandlePrevPage={handlePrevPage}
                    handlechangePageSize={handleChangePageSize}
                    first={() => {
                      getDataCollectionAsync(pages);
                      setPageNum(pages);
                    }}
                    end={() => {
                      getDataCollectionAsync(1);
                      setPageNum(1);
                    }}
                    handleGoPage={handleGoPage}
                  />
                </>
              </div>
            </div>
          ) : (
            <Message message={"NoDataForPreview"} type={messageType} />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};
